import React from "react";
import { validatePanel as V, tones } from "../../mock/inferraData";

export default function ValidatePanel() {
  const pts = V.focus.points;
  const w = 440;
  const h = 110;
  const coords = pts.map((p, i) => {
    const x = 10 + (i * (w - 20)) / (pts.length - 1);
    const y = h - (p / 100) * (h - 12) - 6;
    return [x, y];
  });
  const poly = coords.map((c) => c.join(",")).join(" ");

  return (
    <div className="card-lift" style={{ background: "#fff", border: "1px solid rgba(20,32,27,0.16)", borderRadius: 12, overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <div style={{ height: 52, padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #e6e9e6", gap: 10 }}>
        <span style={{ fontSize: 14, fontWeight: 600 }}>{V.title}</span>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <span className="vp-hide" style={{ fontSize: 12, color: "#5a646e" }}>Dossier format</span>
          <span style={{ fontSize: 12, padding: "6px 10px", border: "1px solid #d8dcd8", borderRadius: 6 }}>{V.dossier}</span>
          <a href="#perimeter" className="btn btn--dark" style={{ height: 32, padding: "0 12px", borderRadius: 6, fontSize: 12 }}>Export dossier</a>
        </div>
      </div>

      <div style={{ padding: "6px 20px 0", fontSize: 13 }}>
        <div className="vp-grid" style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1.1fr 0.6fr 0.6fr 0.9fr", padding: "10px 0", color: "#5a646e", fontSize: 12, borderBottom: "1px solid #e6e9e6" }}>
          <span>Model</span><span>Type</span><span>Last validated</span>
          <span style={{ textAlign: "right" }}>Gini</span>
          <span style={{ textAlign: "right" }}>PSI</span>
          <span style={{ textAlign: "right" }}>Status</span>
        </div>
        {V.rows.map((r, i) => (
          <div key={r.m} className="vp-grid" style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1.1fr 0.6fr 0.6fr 0.9fr", padding: "11px 0", borderBottom: i === V.rows.length - 1 ? "none" : "1px solid #eef0ee", background: r.active ? "#fbf7ef" : "transparent" }}>
            <span style={{ fontWeight: 500 }}>{r.m}</span>
            <span style={{ color: "#45514a" }}>{r.t}</span>
            <span style={{ color: "#45514a" }}>{r.d}</span>
            <span style={{ textAlign: "right", fontFamily: '"IBM Plex Mono", monospace' }}>{r.g}</span>
            <span style={{ textAlign: "right", fontFamily: '"IBM Plex Mono", monospace' }}>{r.p}</span>
            <span style={{ textAlign: "right", color: tones[r.tone], fontWeight: r.tone === "bad" ? 600 : 400 }}>{r.s}</span>
          </div>
        ))}
      </div>

      <div className="vp-focus" style={{ margin: "14px 20px 20px", padding: "16px 18px", borderRadius: 8, background: "#f7f8f6", display: "flex", gap: 24, alignItems: "center" }}>
        <div style={{ width: 220, flexShrink: 0, display: "flex", flexDirection: "column", gap: 6 }}>
          <div style={{ fontSize: 13, fontWeight: 600 }}>{V.focus.title}</div>
          <div style={{ fontSize: 12, lineHeight: 1.5, color: "#45514a" }}>{V.focus.body}</div>
        </div>
        <svg width="100%" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none" style={{ maxWidth: 440, height: 110 }} aria-label="Population stability index rising toward the 0.25 limit">
          <line x1="0" y1="22" x2={w} y2="22" stroke="#8E2F1C" strokeWidth="1" strokeDasharray="4 4" />
          <line x1="0" y1="66" x2={w} y2="66" stroke="#B7832E" strokeWidth="1" strokeDasharray="4 4" />
          <text x={w - 4} y="16" textAnchor="end" fontFamily="IBM Plex Mono, monospace" fontSize="10" fill="#8E2F1C">0.25 limit</text>
          <text x={w - 4} y="60" textAnchor="end" fontFamily="IBM Plex Mono, monospace" fontSize="10" fill="#7A4F0E">0.10 watch</text>
          <polyline points={poly} fill="none" stroke="#14201b" strokeWidth="2" style={{ strokeDasharray: 600, strokeDashoffset: 600, animation: "draw-line 1.8s ease forwards 0.3s", ['--len']: 600 }} />
          <circle cx={coords[coords.length - 1][0]} cy={coords[coords.length - 1][1]} r="4" fill="#B7832E" />
        </svg>
      </div>

      <style>{`
        @media (max-width: 820px) {
          .vp-hide { display: none; }
        }
        @media (max-width: 640px) {
          .vp-focus { flex-direction: column; align-items: flex-start; }
        }
      `}</style>
    </div>
  );
}
